import { useQRSListener } from '../../ecg/hooks/useQRSListener';
import { ThreeLeadPlotContainer } from '../../plot/components/ThreeLeadPlotContainer';
import { RawSignalPlot } from './RawSignalPlot';

export const RawSignalView: React.FC = () => {
  useQRSListener();
  return (
    <>
      <RawSignalPlot />
      <ThreeLeadPlotContainer />
    </>
  );
};
